import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import Spinner from '../Spinner/Spinner';

const ContactUs = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [ContactNo, setContactNo] = useState('');
    const [Message, setMessage] = useState('');
    const [ShowAlert, setShowAlert] = useState(false);

    const isValid = () => {
        
        var result: Boolean = true;

        if(!Name){
            result = false;
        }

        if(!ContactNo){
            result = false;
        }

        if(!Message){
            result = false;
        }

        return result;
    }

    const SendMail = () => {

        if(!isValid()){
            alert('Please fill all required fields');
            return false;
        }

       

            setIsLoading(true);
        const data = {
            Name: Name,
            Email: Email,
            ContactNo: ContactNo,
            Message: Message
        }
        
        apiPost("api/Email/ContactUs", data).then((res: any) => {
            
            setName('');
            setEmail('');
            setContactNo('');
            setMessage('');

            setIsLoading(false);
            setShowAlert(true);
        });
    }



    return (<>

{(isLoading && <Spinner></Spinner>)}
        {/* <!-- Breadcumb Section Start --> */}
        <div className="breadcrumb-img">
            <img src="assets/img/banner/about-banner.jpg" alt="MeriPustak-About" />

        </div>

        {/* <!-- Contact Section Start --> */}
        <section className="contact-section fix section-padding">
            <div className="container">
                <div className="contact-wrapper">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-4">
                            <div className="contact-left-items">
                                <div className="contact-info-area-2">

                                    <div className="contact-info-items mb-4">
                                        <div className="icon">
                                            <i className="icon-icon-3"></i>
                                        </div>
                                        <div className="content">
                                            <p><a href="tel:18008917183">1800 891 7183</a></p>

                                        </div>
                                    </div>
                                    <div className="contact-info-items mb-4">
                                        <div className="icon">
                                            <i className="icon-icon-10"></i>
                                        </div>
                                        <div className="content">
                                            <p><a href="tel:01148405001">1800 891 7183</a></p>

                                        </div>
                                    </div>
                                    <div className="contact-info-items mb-4">
                                        <div className="icon">
                                            <i className="icon-icon-11"></i>
                                        </div>
                                        <div className="content">
                                            <p><a href="mailto:contactus@meripustak.com">contactus@meripustak.com</a></p>

                                        </div>
                                    </div>
                                    <div className="contact-info-items border-none">
                                        <div className="icon">
                                            <i className="icon-icon-12"></i>
                                        </div>
                                        <div className="content">
                                            <p>A Division of Machwan Tech Services Private Limited</p>
                                            <p>

                                                Commercial Building No. A-8 ,
                                                C-Block, Community Centre, Naraina Vihar,
                                                New Delhi - 110028
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="contact-content">
                                <h2>Contact Form:-</h2>

                                <form action="#" id="contact-form" method="POST" className="contact-form-items">
                                    <div className="row g-4">
                                        <div className="col-lg-4 wow fadeInUp" data-wow-delay=".3s">
                                            <div className="form-clt">
                                                <span>Your name*</span>
                                                <input type="text" value={Name} onChange={(e: any) => { setName(e.target.value) }} name="name" id="name" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 wow fadeInUp" data-wow-delay=".5s">
                                            <div className="form-clt">
                                                <span>Your Email</span>
                                                <input type="text" value={Email} onChange={(e: any) => { setEmail(e.target.value) }} name="email" id="email" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 wow fadeInUp" data-wow-delay=".5s">
                                            <div className="form-clt">
                                                <span>Phone No.*</span>
                                                <input type="number" value={ContactNo}  onChange={(e: any) => { setContactNo(e.target.value) }} name="phone" id="phone" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".7s">
                                            <div className="form-clt">
                                                <span>Write Message*</span>
                                                <textarea  value={Message} onChange={(e: any) => { setMessage(e.target.value) }} name="message" id="message"
                                                    placeholder=""></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s">
                                            <button type="button" onClick={SendMail} className="theme-btn">
                                                Send Message <i className="fa-solid fa-arrow-right-long"></i>
                                            </button>
                                        </div>
                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s">
                                            {ShowAlert && <div className="alert alert-success">
                                                Thanks for contacting us. We will get back to you at the earliest.
                                            </div>}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <!--<< Map Section Start >>--> */}
        <div className="map-section">
            <div className="map-items">
                <div className="googpemap">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.179103867095!2d77.13992491468004!3d28.624393732421023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0328d22b5e5b%3A0x55247584e66cce57!2sMeri+Pustak!5e0!3m2!1sen!2sin!4v1492518090153"
                        style={{ border: "0" }} allowFullScreen loading="lazy"></iframe>
                </div>
            </div>
        </div>


    </>);
}
export default ContactUs;